<div *ngIf="isVisible">
  <ng-content></ng-content>
</div>
